import { useEffect, useRef, useState, useCallback } from "react";
import api from "./api";
import { logger } from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useWebSocket(onMessage, enabled = true) {
  const wsRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      let ticket;
      try {
        const { data } = await api.post("/ws/ticket");
        ticket = data?.ticket;
      } catch (err) {
        logger.warn("[ws] could not obtain ws ticket", err);
        return;
      }
      if (cancelled || !ticket) return;
      const wsUrl = BACKEND_URL.replace(/^http/, "ws") + `/api/ws?ticket=${ticket}`;
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;
      ws.onopen = () => setConnected(true);
      ws.onclose = () => setConnected(false);
      ws.onmessage = (ev) => {
        try {
          const data = JSON.parse(ev.data);
          if (onMessageRef.current) onMessageRef.current(data);
        } catch (err) {
          logger.warn("[ws] failed to parse message", err);
        }
      };
    })();
    return () => {
      cancelled = true;
      if (wsRef.current) wsRef.current.close();
    };
  }, [enabled]);

  const send = useCallback((payload) => {
    if (wsRef.current && wsRef.current.readyState === 1) {
      wsRef.current.send(JSON.stringify(payload));
    }
  }, []);

  return { connected, send };
}
